import {
  EnterpriseEventClientHelper,
  EnterpriseEventEndPoint,
} from './enterprise-event-client-helper';

export interface EnterpriseEventSession {
  sessionName: string;
  sessionValue: any;
}

export interface BaseEnterpriseEventRequestPayload {
  type: string;
  source: string;
  metadata?: Record<string, any>;
  subject?: string;
  parentsubject?: string;
  parentrequired?: boolean;
  session?: EnterpriseEventSession;
}

export interface ChildEnterpriseEventRequestPayload
  extends BaseEnterpriseEventRequestPayload {
  subject?: string;
  parentsubject: string;
}

export interface ParentEnterpriseEventRequestPayload
  extends BaseEnterpriseEventRequestPayload {
  subject: string;
  parentsubject?: string;
}

export type EnterpriseEventRequestPayload = (
  | ParentEnterpriseEventRequestPayload
  | ChildEnterpriseEventRequestPayload
) &
  Record<string, any>;

export class EnterpriseEventClient {
  private static instance: EnterpriseEventClient | null = null;
  private enterpriseEventClientHelper = new EnterpriseEventClientHelper();
  private clientIpAddress;
  constructor(
    readonly env: string,
    private readonly localEnterpriseEventEndpoint?: string
  ) {}

  public static getInstance(
    env: string,
    localEnterpriseEventEndpoint?: string
  ): EnterpriseEventClient {
    if (!EnterpriseEventClient.instance) {
      EnterpriseEventClient.instance = new EnterpriseEventClient(
        env,
        localEnterpriseEventEndpoint
      );
    }
    return EnterpriseEventClient.instance;
  }

  public async dispatchEnterpriseEvent(
    eventPayload: EnterpriseEventRequestPayload
  ): Promise<Response> {
    try {
      const enterpriseEventPayload = JSON.stringify(
        this.enterpriseEventClientHelper.mapEnterpriseEvent(
          eventPayload,
          this.clientIpAddress
        )
      );

      if (window.fetch) {
        return fetch(
          this.localEnterpriseEventEndpoint ||
            EnterpriseEventEndPoint[this.env.toUpperCase()],
          {
            method: 'POST',
            body: enterpriseEventPayload,
            credentials: 'omit',
            headers: {
              'Content-Type': 'application/json',
            },
            keepalive: true,
          }
        );
      } else {
        console.warn(`No window fetch support`);
        return Promise.reject(new Error('No window fetch support'));
      }
    } catch (error) {
      console.warn(`Could not dispatch Enterprise Event: ${error.message}`);
      return Promise.reject(error);
    }
  }

  public setClientIpAddress(clientIpAddress: string) {
    this.clientIpAddress = clientIpAddress;
  }
}
